import * as Parse from 'parse';
import { ModelDecorator } from '../decorators';

export default class HashTag extends Parse.Object {

    @ModelDecorator.Variable
    public name: string;

    @ModelDecorator.Variable
    public popularity: number;

    constructor(){super('HashTag')}

    // tslint:disable-next-line:member-ordering
    public static async getHashtagsCount() {
        return new Parse.Query(HashTag).count()
    }

    // tslint:disable-next-line:member-ordering
    public static async searchHashTag(s:string, limit = 10000, skip = 0, isCount = false){
        s = s.toLowerCase();
        const searchQuery = new Parse.Query(HashTag)
        searchQuery.matches('name',new RegExp(s,'i'),null)
        searchQuery.descending('createdAt')
        if(isCount){
            return searchQuery.count();
        } else {
            searchQuery.limit(limit);
            searchQuery.skip(skip);
            return searchQuery.find();
        }
    }

    // tslint:disable-next-line:member-ordering
    public static async loadHashtags(skip = 0, limit = 25) {
        return new Parse.Query(HashTag)
            .descending('createdAt')
            .limit(limit)
            .skip(skip)
            .find()
    }

    // tslint:disable-next-line:member-ordering
    public static async getHashTag(id:string){
        return new Parse.Query(HashTag)
        .get(id)
    }
}

Parse.Object.registerSubclass('HashTag', HashTag);


// WEBPACK FOOTER //
// ./src/models/HashTag.ts